var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 41,
    viewBox: "0 0 57 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2508_51027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 41.0015H24V6.21146C24 6.10146 24.1778 6.00146 24.4111 6.00146H33.5889C33.8222 6.00146 34 6.10146 34 6.21146V41.0015Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 41.0015H12.5V11.28C12.5 11.13 12.698 11.0015 12.951 11.0015H23.049C23.302 11.0015 23.5 11.13 23.5 11.28V41.0015Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 41.0015H2V24.2381C2 24.1001 2.18339 24.0015 2.40992 24.0015H11.5901C11.8166 24.0015 12 24.1001 12 24.2381V41.0015Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 41.0015H45V28.1824C45 28.0769 45.1834 28.0015 45.4099 28.0015H54.5901C54.8166 28.0015 55 28.0769 55 28.1824V41.0015Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 41.0015H34.5V19.4729C34.5 19.2136 34.6778 19.0015 34.9111 19.0015H44.0889C44.3222 19.0015 44.5 19.2136 44.5 19.4729V41.0015Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 40.5636H56.5",
    stroke: "#2B2B35",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2508_51027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.563599)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistogram);
export default __webpack_public_path__ + "static/media/histogram.a8ee17cf5dbb7e08cd1a79a9dfb8480b.svg";
export { ForwardRef as ReactComponent };